module.exports = __webpack_public_path__ + "static/media/textfile.69c3b134.svg";